<template>
  <div class="overflow-hidden">
    <div class="plansHolder row">
      <div class="planHolder col-lg-4 col-md-6 col-12"
           v-for="(paket,index) in pakets" :key="paket.id"
           :class="currentPaketChoosed(paket)"
           :id="paket.id"

      >
        <div class="planBody">
          <div class="popularPaket" v-if="paket.standard_choice"><i class="icon-gotit"></i>Populär val</div>
          <div class="contentHolder">
            <div class="floorplanTitle" @click="showPoints(paket.id)">
              <span v-html="paket.title"></span>
              <span class="paketprice ">{{ paket.price }} kr</span>
            </div>
            <div class="floortplan_description"  @click="showPoints(paket.id)">{{ paket.description }} <span class="read_more_points">Läs mer..</span></div>
            <div class="floortplan_description_points mgb-30">
              <div class="points">
                <ul>
                  <li v-for="(point,index) in paket.points" :key="'points_'+index"> {{ point.point }}</li>
                </ul>
              </div>
            </div>
            <div class="button_holder_paket"            @click="commit_paket(paket,index)">
              <button class="checkout_btn_primary rounded-btn mgt-10"><span v-if="currentChoice(paket)">Har valts</span><span
                  v-else>Välj</span></button>
              <div class="new_gararage">Ny byggnation av garage</div>
            </div>
          </div>
        </div>

      </div>
      <div class="col-lg-8">
        <label class="d-flex gap-2 align-items-start">
          <input type="checkbox" :checked="hasHelpService" class="form-check" id=""
                 @change="commit_help_service($event)">
          <span class="d-flex gap-1 flex-column">
            <span style="font-size:14px">Behöver du hjälp med din bygglovsansökan? Kontakta oss för en offert.</span>
    <small style="font-size:11px">
Vi hjälper dig att ta fram och skicka in alla nödvändiga handlingar till kommunen som en del av bygglovsprocessen. Kostnaden specificeras i en separat offert baserat på projektets omfattning.
    </small>
          </span>
        </label>
      </div>
      <div class="col-lg-4 d-flex align-items-start justify-content-end gap-2">
        <button class="checkout_btn_primary rounded-btn" @click.prevent="nextStep" :disabled="!hasPaket">Nästa</button>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "floorplans_paket",
  computed: {
    activeLeftNav() {
      return this.$store.state.activeLeftNav
    },
    pakets() {
      return this.$store.state.pakets
    },
    currentPaket() {
      return this.$store.state.currentPaket
    },
    hasPaket() {
      return Object.keys(this.$store.state.currentPaket).length > 0
    },
    hasHelpService() {
      const index = this.$store.state.order.order_lines.findIndex(line => line.reference === 'BYGGLOV_HELP');
      return index > -1
    },

  },
  methods: {
    commit_help_service(e) {
      this.$store.commit('commit_service_help', e.target.checked)
    },
    currentChoice(paket) {
      if (Object.keys(this.$store.state.currentPaket).length > 0) {
        return this.$store.state.currentPaket.id === paket.id ?? true
      } else {
        return false
      }
    },
    currentPaketChoosed(paket) {
      if (Object.keys(this.$store.state.currentPaket).length > 0) {
        return this.$store.state.currentPaket.id === paket.id ? 'active' : ''
      } else {
        return paket.standard_choice ? 'active' : ''
      }
    },
    dispatch_Nav(e) {
      this.$store.dispatch('commit_activeLeftNav', e)

    },
    choosePaket() {
      if (Object.keys(this.currentPaket).length > 0) {
        this.dispatch_Nav('payment')
      }
    },
    commit_paket(e, index) {
      this.$store.dispatch('commit_paket', {paket: e, index: index})
    },
    nextStep() {
      this.$store.commit('mutate_activeLeftNav', 'payment')
      this.$store.dispatch('create_order')
    },
    showPoints(id) {
      console.log(id)
      document.getElementById(id).classList.toggle('visible_points')
    }
  }
}
</script>

<style scoped lang="scss">
.popularPaket {
  padding: 4.99751px 9.99501px;
  gap: 10px;
  display: flex;
  background: #FFF0EE;
  font-weight: 400;
  font-size: 14.9925px;
  line-height: 130%;
  text-align: center;
  color: #CA3214;
  align-items: center;
  justify-content: center;
}

.button_holder_paket {
  display: flex;
  gap: 18px;
  flex-direction: column;

  & > div {
    font-size: 14.9925px;
    line-height: 130%;
    text-align: center;
    color: #8F8F8F;
  }
}


.plansHolder {


  padding: 20px 30px 30px;

  .planHolder {
    margin-bottom: 20px;

    &:hover {
      .planBody {
        box-shadow: -1.24938px 0px 0px 1.24938px rgba(0, 0, 0, 0.05), 0px 2.49875px 7.49626px rgba(0, 0, 0, 0.11), 0px 6.24688px 14.9925px rgba(0, 0, 0, 0.05), 0px 0px 0px 1.24938px rgba(0, 0, 0, 0.05);
      }
    }

    &.active {
      button {
        background-color: #4E9280 !important;
        border: #4E9280;
      }

      .planBody {
        box-shadow: -1.24938px 0px 0px 1.24938px rgba(0, 0, 0, 0.05), 0px 2.49875px 7.49626px rgba(0, 0, 0, 0.11), 0px 6.24688px 14.9925px rgba(0, 0, 0, 0.05), 0px 0px 0px 1.24938px rgba(0, 0, 0, 0.05);
      }
    }

    .planBody {
      box-shadow: 0px 1.24938px 2.49875px rgba(0, 0, 0, 0.06), 0px 0px 0px 1.24938px rgba(104, 113, 130, 0.16), 0px 1.24938px 1.24938px rgba(82, 86, 95, 0.08);
      border-radius: 9.99501px;
      cursor: pointer;
      height: 100%;

      .paketprice {
        font-size: 18px;
      }

      .contentHolder {
        padding: 15px 12px;
        display: flex;
        flex-direction: column;
        height: calc(100% - 20px);
      }

      .floorplanTitle {
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        color: #000000;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 5px;
      }

      .floortplan_description {
        font-weight: 400;
        font-size: 14px;
        line-height: 167%;
        color: #6F6F6F;
      }
    }

  }
}
.floortplan_description_points {
  font-weight: 400;
  font-size: 14px;
  line-height: 167%;
  height: 100%;
  @media screen and (max-width: 769px){
    display: none;
  }

  ul {
    padding: 20px 20px;

    li {
      line-height: 167%;
    }
  }
}

.new_gararage{
  @media screen and (max-width: 769px) {
    display: none;
  }
}
.read_more_points{
  @media screen and (min-width: 769px) {
    display: none;
  }
}

</style>
<style>
.visible_points  .floortplan_description_points{
  display: block!important;
}
.visible_points .read_more_points{
  display: none !important;
}
</style>
